module.exports = __webpack_public_path__ + "img/mini-program-pc.f01c8efe.jpg";